module.exports = __webpack_public_path__ + "img/progress_098.0fd45a62.png";